import ComissionedList from './ComissionedList';

export default ComissionedList;